var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Displays and updates the number of antennas associated with the current external damage.
 * touches: external damage state, antenna-specific labels and title translations.
 * invariants: the antenna count is read from the current external damage and must be at least 1 when changed through the incremental input.
 * inputs: current antenna external damage data, antenna translation constants.
 * outputs: renders the antenna title and count field, updates the external damage antenna count through the shared ExternalDamageComponent logic.
 * see: ExternalDamageComponent, AntennaConstants
 */
import Component from 'vue-class-component';
import { UiIncremental, UiCard } from '@claims-ia/design-system';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { ExternalDamageComponent } from '@declaration/components/externalDamage/ExternalDamageComponent';
import { ANTENNA_COUNT_LABEL, ANTENNA_TITLE, } from '@declaration/constants/externalDamages/AntennaConstants';
let Antenna = class Antenna extends ExternalDamageComponent {
    get title() {
        return this.translateExternalDamageKey(ANTENNA_TITLE);
    }
    get antennaCountLabel() {
        return this.translateExternalDamageKey(ANTENNA_COUNT_LABEL);
    }
    get antennaCount() {
        var _a;
        return (_a = this.externalDamage.antennaCount) !== null && _a !== void 0 ? _a : null;
    }
    set antennaCount(antennaCount) {
        this.updateExternalDamage({ antennaCount });
    }
};
Antenna = __decorate([
    Component({
        components: {
            RadioPrimaryButton,
            UiIncremental,
            UiCard,
        },
    })
], Antenna);
export default Antenna;
